const IconPuzzle = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 5.5a2.5 2.5 0 1 1 5 0V7h1a1 1 0 0 1 1 1v3h-1.5a2.5 2.5 0 1 0 0 5H21v3a1 1 0 0 1-1 1h-3v-1.5a2.5 2.5 0 1 0-5 0V20H9a1 1 0 0 1-1-1v-3H6.5a2.5 2.5 0 1 1 0-5H8V8a1 1 0 0 1 1-1h5V5.5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconPuzzle
